import { getAutoOnboardingApiUrl, getAutoOnboardingV2Url } from './commonV2'

export const autoOnboardingApiUrl = getAutoOnboardingApiUrl() + '/api/v1/'

export const autoOnboardingApiUrlV2 = getAutoOnboardingV2Url() + '/api/'



// WEBPACK FOOTER //
// ./src/utils/constantsV2.ts